var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.881,
    height: 186.153,
    viewBox: "0 0 161.881 186.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866",
    transform: "translate(-111.496 -120.149)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 16.839,
    cy: 16.839,
    r: 16.839,
    transform: "translate(115.819 161.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16265",
    "data-name": "Rectangle 16265",
    width: 136.413,
    height: 0.943,
    transform: "translate(136.965 305.358)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M627.029,583.111a2.761,2.761,0,0,1-.265-.53l-2.174-5.821a2.74,2.74,0,0,1,1.606-3.521l48.515-18.116a2.739,2.739,0,0,1,3.521,1.606l2.174,5.821a2.736,2.736,0,0,1-1.606,3.521l-48.515,18.116a2.739,2.739,0,0,1-3.256-1.076Z",
    transform: "translate(-481.659 -357.577)",
    fill: "#c3d52c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M713.91,551.569l-19.729,7.867a2.526,2.526,0,0,0-1.723,3.031l2.289,9.167a2.526,2.526,0,0,0,3.526,1.673L718.057,564a2.531,2.531,0,0,0,1.484-3.249l-2.378-7.694a2.53,2.53,0,0,0-3.253-1.484Z",
    transform: "translate(-521.012 -355.526)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M801.856,609.826a2.739,2.739,0,0,1-2.9-1.827l-16.887-48.956a2.736,2.736,0,0,1,1.694-3.479l5.874-2.026a2.738,2.738,0,0,1,3.479,1.695L810,604.188a2.74,2.74,0,0,1-1.695,3.479l-5.874,2.026A2.761,2.761,0,0,1,801.856,609.826Z",
    transform: "translate(-572.854 -356.671)",
    fill: "#c3d52c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M794.5,553.435l6.481,20.226a2.526,2.526,0,0,1-1.242,3.258l-8.529,4.065a2.526,2.526,0,0,1-3.534-1.656l-5.4-21.187a2.53,2.53,0,0,1,1.563-3.212l7.449-3.06A2.53,2.53,0,0,1,794.5,553.435Z",
    transform: "translate(-572.981 -355.712)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M752.581,733.359h-6.213a2.739,2.739,0,0,1-2.736-2.736V678.836a2.74,2.74,0,0,1,2.736-2.736h6.213a2.74,2.74,0,0,1,2.736,2.736v51.787A2.74,2.74,0,0,1,752.581,733.359Z",
    transform: "translate(-550.686 -427.724)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M781.773,733.359H775.56a2.74,2.74,0,0,1-2.736-2.736V678.836a2.74,2.74,0,0,1,2.736-2.736h6.214a2.74,2.74,0,0,1,2.736,2.736v51.787A2.739,2.739,0,0,1,781.773,733.359Z",
    transform: "translate(-567.588 -427.724)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M763.363,606.46H735.131a2.95,2.95,0,0,1-2.947-2.947V557.649a17.063,17.063,0,1,1,34.126,0v45.864a2.95,2.95,0,0,1-2.947,2.947Z",
    transform: "translate(-544.058 -349.259)",
    fill: "#bec3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M796.655,612.45H782.341V531.556l.266.073a19.105,19.105,0,0,1,14.048,18.392Z",
    transform: "translate(-573.099 -344.031)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M740.64,612.45H726.326v-62.43a19.105,19.105,0,0,1,14.048-18.392l.266-.073Z",
    transform: "translate(-540.666 -344.031)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 22.531,
    cy: 22.531,
    r: 22.531,
    transform: "translate(182.445 136.778)",
    fill: "#c3d52c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M757.733,405.484s1.263-34.942-15.155-23.575c0,0-9.472-31.784-32.626,15.787l-6.736,6.736s30.311-4.21,58.517,8.841Z",
    transform: "translate(-527.284 -251.362)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M765.032,471.323a7.746,7.746,0,0,1-4.458-1.062,3.424,3.424,0,0,1-1.347-2.557,2.3,2.3,0,0,1,.783-1.892,2.972,2.972,0,0,1,2.811-.4l-1.136-8.3.834-.114,1.336,9.763-.7-.32a2.549,2.549,0,0,0-2.605.023,1.48,1.48,0,0,0-.485,1.219,2.587,2.587,0,0,0,1,1.906,6.965,6.965,0,0,0,3.985.9Z",
    transform: "translate(-559.713 -300.856)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16266",
    "data-name": "Rectangle 16266",
    width: 4.535,
    height: 0.842,
    transform: "translate(193.312 156.965)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16267",
    "data-name": "Rectangle 16267",
    width: 4.535,
    height: 0.842,
    transform: "translate(207.626 156.965)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M627.963,577.248a2.526,2.526,0,0,1-3.354-1.228L610.08,544.705a2.526,2.526,0,1,1,4.583-2.126l14.529,31.314a2.526,2.526,0,0,1-1.228,3.354Z",
    transform: "translate(-473.221 -349.566)",
    fill: "#052a6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    d: "M578.875,499.549a20.207,20.207,0,1,1,9.826-26.835,20.207,20.207,0,0,1-9.826,26.835Zm-14.883-32.078a15.155,15.155,0,1,0,20.126,7.369A15.155,15.155,0,0,0,563.992,467.471Z",
    transform: "translate(-438.662 -303.181)",
    fill: "#052a6e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.5feadda36de8e4e30aa1770624c7aef6.svg";
export { ForwardRef as ReactComponent };